// @ts-strict
import { AfterViewInit, ChangeDetectionStrategy, Component, Input, OnInit, } from '@angular/core';
import { LMContextService } from "@app/services";
import { LMReportPersonalizationDialogService } from "@app/components";
import {AppConstants} from "@app/utils";


/*
TODO
1. Archive reports should disable everything
 */
@Component({
  selector: 'lm-list-personalization-source',
  standalone: false,
  templateUrl: './lm-list-personalization-source.component.html',
  styleUrls: [ 'lm-list-personalization-source.component.scss' ],
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush
  })

export class LMListPersonalizationSourceComponent implements OnInit, AfterViewInit {
  get model(): LMListPersonalizationInfo  {
    return this._model;
  }
  
  @Input() set model(model: LMListPersonalizationInfo) {
    this._model = model;
    this.updateConditions();
  }

  private _model!: LMListPersonalizationInfo;

  readonlyDataSource = false;
  readonlyAsOfDate = false;
  dataOptionText!: string;
  asOfDateText!: string;
  archiveFeatureEnabled!: boolean;

  asOfDatePickerOptions: SohoDatePickerOptions = {
    mode: 'standard',
    dateFormat: Soho.Locale.calendar().dateFormat.short,
    showMonthYearPicker: true
  };
  constructor(
      private lmContextService: LMContextService,
      private lmReportPersonalizationDialogService: LMReportPersonalizationDialogService) {
    // no-op
  }

  ngOnInit() {
    this.archiveFeatureEnabled = this.lmContextService.isConfigFeatureEnabled(AppConstants.FEATURE_ShowArchive);
  }
  ngAfterViewInit() {
    // no-op
  }
  onDataOptionChanged() {
    this.updateConditions();
  }

  private updateConditions() {
    this.readonlyDataSource = !this.lmReportPersonalizationDialogService.isDataSourceChangeable(this.model);
    this.readonlyAsOfDate = !this.lmReportPersonalizationDialogService.isAsOfDateCapable(this.model);
    this.dataOptionText = this.lmReportPersonalizationDialogService.buildDataSourceText(this.model);
    this.asOfDateText = this.lmReportPersonalizationDialogService.buildAsOfDateText(this.model);
  }

  // protected readonly LMPersonalizationDataSource = LMPersonalizationDataSource;
}

